// removed by extract-text-webpack-plugin
module.exports = {"preview":"_26TQB0bEaC6yfzYyWOWAfi"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/components/Notification/constants/notificationsSet.css
// module id = 1310
// module chunks = 0